import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useLang } from "@/i18n/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { Stars } from "./Stars";

export const ReviewDialog = ({ open, onOpenChange, onCreated }) => {
  const { t, lang } = useLang();
  const { user } = useAuth();
  const isMember = user?.status === "approved";
  const [form, setForm] = useState({ name: "", rating: 5, text: "" });
  const [busy, setBusy] = useState(false);
  const f = t.reviews.form;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/reviews", { ...form, name: isMember ? user.name : form.name, lang });
      toast.success(isMember ? f.okMember : f.okGuest);
      setForm({ name: "", rating: 5, text: "" });
      onOpenChange(false);
      onCreated?.();
    } catch (err) {
      toast.error(errMsg(err, t.common.error));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0b0e26] border-white/10 text-white sm:max-w-lg" data-testid="review-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{f.title}</DialogTitle>
          <DialogDescription className="text-slate-300">{isMember ? f.memberNote : f.guestNote}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5 mt-2">
          {!isMember && (
            <input required minLength={2} maxLength={60} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder={f.name} className="field" data-testid="review-name-input" />
          )}
          <div>
            <p className="mb-2 font-mono text-xs uppercase tracking-widest text-slate-400">{f.rating}</p>
            <Stars value={form.rating} size="w-7 h-7" onChange={(n) => setForm({ ...form, rating: n })} testid="review-rating" />
          </div>
          <textarea required minLength={10} maxLength={800} rows={5} value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })}
            placeholder={f.text} className="field resize-none" data-testid="review-text-input" />
          <button disabled={busy} className="btn-chrome w-full rounded-full py-3 font-semibold text-[#050713] disabled:opacity-60" data-testid="review-submit-button">
            {busy ? f.sending : f.submit}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
